import React, { SVGProps } from 'react'
const SvgLockOpenSidenav = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke="#1B2C4F"
      strokeWidth={1.5}
      d="M10.1 2H12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-1.9m0-12H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h6.1m0-12v12"
    />
  </svg>
)
export default SvgLockOpenSidenav
